import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import TextInput from '../../../../core/form/TextInput';
import AnswersInputContainer from '../inputs/AnswersInputContainer';
import LocalFileInput from '../../../../core/form/LocalFileInput';

const SingleChoiceGameItemForm = (props) => (
  <div>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Text"
          fieldType="input"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Image Prompt"
          fieldType="textarea"
          textAreaRows="4"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'imagePrompt', '')}
          onChange={(value) => props.onChange('imagePrompt', value)}
          errorText={get(props.errors, 'imagePrompt', '')}
        />
      </Column>
    </Row>
    <Row>
      <Column size={4}>
        <LocalFileInput
          label="Upload an image to the item"
          accept="image"
          cropSize={{ width: 960, height: 640 }}
          disabled={props.disabled}
          value={get(props.values, 'image', '')}
          onChange={(key) => props.onChange('image', key)}
          errorText={get(props.errors, 'image', '')}
        />
      </Column>
    </Row>
    <AnswersInputContainer
      value={get(props.values, 'answers', [])}
      onChange={(answers) => props.onChange('answers', answers)}
      errorText={get(props.errors, 'answers', '')}
      type="SINGLE_CHOICE_GAME"
      disabled={props.disabled}
    />
  </div>
);

SingleChoiceGameItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

SingleChoiceGameItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  disabled: false,
};

export default SingleChoiceGameItemForm;
